import React from "react";
import { usePermissions } from "../utils/permissions";

/**
 * PermissionGate Component
 * Renders children only if user has the required permission
 */
const PermissionGate = ({ resource, action, children, fallback = null }) => {
  const { hasPermission } = usePermissions();

  if (hasPermission(resource, action)) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};

export default PermissionGate;

